











import { Component, Vue, Emit } from 'vue-property-decorator';
@Component({
  name: 'Navbar',
  components: {
  },
})
export default class Navbar extends Vue {
  isFold = false;

  @Emit('clickFold')

  toggleFold() {
    this.isFold = !this.isFold;
    return this.isFold;
  }
}
